/* KaminWelt — Modellvergleich: bis zu 3 Produkte merken (localStorage) und auf /pages/vergleich gegenüberstellen. */
(function () {
  if (window.__kwCompare) return;
  window.__kwCompare = true;

  var KEY = 'kw_compare';
  var MAX = 3;
  var PAGE = '/pages/vergleich';

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v.slice(0, MAX) : []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }
  function has(list, h) { return list.some(function (x) { return x.h === h; }); }

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function money(cents) {
    var n = (cents || 0) / 100;
    try { return '€' + n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    catch (e) { return '€' + n.toFixed(2); }
  }
  function num(v) {
    if (v == null || v === '') return '';
    var n = Number(v);
    if (isNaN(n)) return String(v);
    return n.toLocaleString('de-DE', { maximumFractionDigits: 2 });
  }

  var SWAP = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 4L3 8l4 4M3 8h13M17 20l4-4-4-4M21 16H8"/></svg>';
  var X = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  /* ---------- Schalter auf den Karten ---------- */

  function paintToggles() {
    var list = read();
    Array.prototype.forEach.call(document.querySelectorAll('[data-kw-compare]'), function (b) {
      var on = has(list, b.getAttribute('data-kw-compare'));
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-on', on);
      var lab = b.querySelector('.kw-cmp__label');
      if (lab) lab.textContent = on ? 'Im Vergleich' : 'Vergleichen';
    });
  }

  /* ---------- Leiste unten ---------- */

  var bar = null, msgTimer = null;

  function ensureBar() {
    if (bar) return bar;
    bar = document.createElement('div');
    bar.className = 'kw-cmpbar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Modellvergleich');
    bar.hidden = true;
    document.body.appendChild(bar);
    return bar;
  }

  function paintBar(message) {
    if (document.querySelector('[data-kw-compare-page]')) return;
    var list = read();
    var b = ensureBar();
    if (!list.length) { b.hidden = true; document.documentElement.classList.remove('kw-has-cmpbar'); return; }
    var slots = '';
    for (var i = 0; i < MAX; i++) {
      var it = list[i];
      slots += it
        ? '<span class="kw-cmpbar__slot"><img src="' + esc(it.img) + '" alt="' + esc(it.t) + '" width="56" height="56"><button type="button" class="kw-cmpbar__rm" data-kw-compare-rm="' + esc(it.h) + '" aria-label="' + esc(it.t) + ' entfernen">' + X + '</button></span>'
        : '<span class="kw-cmpbar__slot kw-cmpbar__slot--empty" aria-hidden="true">+</span>';
    }
    var ready = list.length >= 2;
    b.innerHTML =
      '<div class="kw-cmpbar__inner">'
      + '<span class="kw-cmpbar__icon">' + SWAP + '</span>'
      + '<div class="kw-cmpbar__text"><strong>Modellvergleich</strong><span>' + (message || (list.length + ' von ' + MAX + ' Modellen' + (ready ? '' : ' – wählen Sie mindestens 2'))) + '</span></div>'
      + '<div class="kw-cmpbar__slots">' + slots + '</div>'
      + '<a class="kw-cmpbar__go' + (ready ? '' : ' is-disabled') + '" href="' + PAGE + '"' + (ready ? '' : ' aria-disabled="true" tabindex="-1"') + '>Jetzt vergleichen</a>'
      + '<button type="button" class="kw-cmpbar__clear" data-kw-compare-clear>Leeren</button>'
      + '</div>';
    b.hidden = false;
    document.documentElement.classList.add('kw-has-cmpbar');
  }

  function flash(message) {
    paintBar(message);
    clearTimeout(msgTimer);
    msgTimer = setTimeout(function () { paintBar(); }, 2600);
  }

  /* ---------- Aktionen ---------- */

  function toggle(btn) {
    var h = btn.getAttribute('data-kw-compare');
    var list = read();
    if (has(list, h)) {
      list = list.filter(function (x) { return x.h !== h; });
    } else {
      if (list.length >= MAX) { flash('Maximal ' + MAX + ' Modelle – bitte zuerst eines entfernen.'); return; }
      list.push({ h: h, t: btn.getAttribute('data-title') || h, img: btn.getAttribute('data-img') || '' });
    }
    write(list);
    paintToggles();
    paintBar();
  }

  function removeHandle(h) {
    write(read().filter(function (x) { return x.h !== h; }));
    paintToggles();
    paintBar();
    if (document.querySelector('[data-kw-compare-page]')) renderPage();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var t = e.target.closest('[data-kw-compare]');
    if (t) { e.preventDefault(); e.stopPropagation(); toggle(t); return; }
    var rm = e.target.closest('[data-kw-compare-rm]');
    if (rm) { e.preventDefault(); removeHandle(rm.getAttribute('data-kw-compare-rm')); return; }
    if (e.target.closest('[data-kw-compare-clear]')) {
      e.preventDefault(); write([]); paintToggles(); paintBar();
      if (document.querySelector('[data-kw-compare-page]')) renderPage();
      return;
    }
    var go = e.target.closest('.kw-cmpbar__go.is-disabled');
    if (go) { e.preventDefault(); flash('Bitte mindestens 2 Modelle auswählen.'); }
  });

  /* ---------- Vergleichsseite ---------- */

  function spec(p, words, not) {
    var specs = p.specs || [];
    for (var i = 0; i < specs.length; i++) {
      var k = specs[i].k.toLowerCase();
      var hit = words.some(function (w) { return k.indexOf(w) > -1; });
      var bad = (not || []).some(function (w) { return k.indexOf(w) > -1; });
      if (hit && !bad) { specs[i].used = true; return specs[i].v; }
    }
    return '';
  }

  function eekHtml(v) {
    if (!v) return '';
    var c = String(v).trim().toLowerCase().replace(/\+/g, 'p');
    return '<span class="kw-eekm kw-eekm--' + esc(c) + '">' + esc(v) + '</span>';
  }

  function stars(r, n) {
    if (!n) return '<span class="kw-cmp-muted">Noch keine</span>';
    var full = Math.round(Number(r) || 0), s = '';
    for (var i = 1; i <= 5; i++) s += i <= full ? '★' : '☆';
    return '<span class="kw-cmp-stars">' + s + '</span> <span class="kw-cmp-muted">(' + n + ')</span>';
  }

  function firstNumber(s) {
    var m = String(s || '').replace(/\./g, '').replace(',', '.').match(/-?\d+(\.\d+)?/);
    return m ? parseFloat(m[0]) : NaN;
  }

  function renderPage() {
    var root = document.querySelector('[data-kw-compare-page]');
    if (!root) return;
    var list = read();
    var table = root.querySelector('[data-kw-compare-table]');
    var empty = root.querySelector('[data-kw-compare-empty]');
    var tools = root.querySelector('[data-kw-compare-tools]');
    if (!list.length) { table.innerHTML = ''; empty.hidden = false; tools.hidden = true; return; }
    empty.hidden = true;
    table.innerHTML = '<p class="kw-cmp-loading">Modelle werden geladen …</p>';

    Promise.all(list.map(function (it) {
      return fetch('/products/' + encodeURIComponent(it.h) + '?view=compare', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (t) { try { return t ? JSON.parse(t) : null; } catch (e) { return null; } })
        .catch(function () { return null; });
    })).then(function (items) {
      var ps = items.filter(function (p) { return p && p.handle; });
      if (!ps.length) { table.innerHTML = ''; empty.hidden = false; tools.hidden = true; return; }
      tools.hidden = ps.length < 2;

      var rows = [
        { l: 'Preis', f: function (p) { return '<strong class="kw-cmp-price">' + money(p.price) + '</strong>'; }, n: function (p) { return p.price; }, best: 'min' },
        { l: 'Marke', f: function (p) { return esc(p.vendor); } },
        { l: 'Nennwärmeleistung', f: function (p) { return p.kw != null ? num(p.kw) + ' kW' : esc(spec(p, ['nennwärmeleistung', 'gesamtleistung', 'heizleistung'], ['wasser', 'raum'])); } },
        { l: 'Raumheizvermögen', f: function (p) { return p.m2 ? 'bis ' + num(p.m2) + ' m²' : (p.m3 ? 'bis ' + num(p.m3) + ' m³' : esc(spec(p, ['raumheiz', 'beheizbar', 'heizfläche']))); } },
        { l: 'Energieeffizienzklasse', f: function (p) { return eekHtml(p.eek || spec(p, ['energieeffizienzklasse'])); } },
        { l: 'Wirkungsgrad', f: function (p) { return esc(spec(p, ['wirkungsgrad', 'energieeffizienz bei'])); }, n: function (p) { return firstNumber(spec(p, ['wirkungsgrad', 'energieeffizienz bei'])); }, best: 'max' },
        { l: 'Wasserführend', f: function (p) { var w = spec(p, ['wasserwärmeleistung', 'wasserleistung', 'wärmeleistung wasser']); return p.water ? 'Ja' + (w ? ' · ' + esc(w) : '') : 'Nein'; } },
        { l: 'Backofen / Backfach', f: function (p) { var b = spec(p, ['backofen', 'backfach']); return p.oven ? 'Ja' + (b ? ' · ' + esc(b) : '') : 'Nein'; } },
        { l: 'Rauchrohranschluss', f: function (p) { return esc(spec(p, ['rauchrohr', 'schornsteinanschluss', 'schornsteindurchmesser', 'abgasstutzen'])); } },
        { l: 'Abmessungen (B × T × H)', f: function (p) { return esc(spec(p, ['gesamtmaß', 'abmessungen', 'maße'], ['brenn', 'back', 'tür', 'öffnung'])); } },
        { l: 'Brennraum', f: function (p) { return esc(spec(p, ['brennkammer', 'brennraum (', 'brennraum:', 'brennraum'], ['öffnung'])); } },
        { l: 'Gewicht', f: function (p) { return p.weight ? num(p.weight) + ' kg' : esc(spec(p, ['gewicht'])); } },
        { l: 'Abgastemperatur', f: function (p) { return esc(spec(p, ['abgastemperatur'])); } },
        { l: 'Brennstoff', f: function (p) { return esc(p.fuel || spec(p, ['brennstoff'])); } },
        { l: 'Bewertungen', f: function (p) { return stars(p.rating, p.rating_count); } }
      ];

      var body = rows.map(function (r) {
        var cells = ps.map(r.f);
        if (r.best && ps.length > 1) {
          var nums = ps.map(r.n);
          var valid = nums.filter(function (v) { return !isNaN(v); });
          if (valid.length > 1) {
            var target = r.best === 'min' ? Math.min.apply(null, valid) : Math.max.apply(null, valid);
            var uniq = valid.filter(function (v) { return v === target; }).length < valid.length;
            if (uniq) cells = cells.map(function (c, i) { return nums[i] === target ? '<span class="kw-cmp-best">' + c + '<em>Bestwert</em></span>' : c; });
          }
        }
        return rowHtml(r.l, cells);
      }).join('');

      /* weitere Angaben aus den technischen Daten, die noch nicht vorkommen */
      var extra = [];
      ps.forEach(function (p) {
        (p.specs || []).forEach(function (s) {
          var key = s.k.replace(/\s+/g, ' ').trim();
          if (s.used || /^(energieeffizienzklasse|nennwärmeleistung|gewicht)\b/i.test(key)) return;
          if (!key || extra.some(function (e) { return e.toLowerCase() === key.toLowerCase(); })) return;
          extra.push(key);
        });
      });

      var head = '<tr><th class="kw-cmp-corner" scope="col"><span>' + ps.length + ' Modelle</span></th>' + ps.map(function (p) {
        var buy = p.available
          ? '<form method="post" action="/cart/add" class="kw-cmp-buy"><input type="hidden" name="id" value="' + esc(p.variant_id) + '"><button type="submit" class="kw-card2__buy">In den Warenkorb</button></form>'
          : '<a class="kw-card2__buy kw-card2__buy--ghost" href="' + esc(p.url) + '">Details ansehen</a>';
        return '<th scope="col" class="kw-cmp-prod">'
          + '<button type="button" class="kw-cmp-x" data-kw-compare-rm="' + esc(p.handle) + '" aria-label="' + esc(p.title) + ' entfernen">' + X + '</button>'
          + '<a class="kw-cmp-img" href="' + esc(p.url) + '"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" width="500" height="500"></a>'
          + '<a class="kw-cmp-title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>'
          + buy + '</th>';
      }).join('')
        + (ps.length < MAX ? '<th scope="col" class="kw-cmp-add"><a href="/collections/kaminoefen"><span>+</span>Weiteres Modell hinzufügen</a></th>' : '')
        + '</tr>';

      function rowHtml(label, cells, cls) {
        var vals = cells.map(function (c) { return String(c || '').replace(/<[^>]+>/g, '').trim(); });
        var same = vals.every(function (v) { return v === vals[0]; });
        var allEmpty = vals.every(function (v) { return !v; });
        if (allEmpty) return '';
        return '<tr class="' + (cls || '') + (same && ps.length > 1 ? ' is-same' : '') + '"><th scope="row">' + esc(label) + '</th>'
          + cells.map(function (c) { return '<td>' + (c || '<span class="kw-cmp-muted">–</span>') + '</td>'; }).join('')
          + (ps.length < MAX ? '<td class="kw-cmp-add"></td>' : '') + '</tr>';
      }

      var more = extra.map(function (k) {
        return rowHtml(k, ps.map(function (p) {
          var s = (p.specs || []).filter(function (x) { return x.k.replace(/\s+/g, ' ').trim().toLowerCase() === k.toLowerCase(); })[0];
          return s ? esc(s.v) : '';
        }), 'kw-cmp-more');
      }).join('');

      table.innerHTML = '<div class="kw-cmp-scroll"><table class="kw-cmp-table">'
        + '<thead>' + head + '</thead><tbody>' + body
        + (more ? '<tr class="kw-cmp-sep"><th colspan="' + (ps.length + 1 + (ps.length < MAX ? 1 : 0)) + '">Alle technischen Daten</th></tr>' + more : '')
        + '</tbody></table></div>';

      var diff = root.querySelector('[data-kw-compare-diff]');
      if (diff) root.classList.toggle('kw-cmp--diff', diff.checked);
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-kw-compare-diff]')) {
      var root = document.querySelector('[data-kw-compare-page]');
      if (root) root.classList.toggle('kw-cmp--diff', e.target.checked);
    }
  });

  window.addEventListener('storage', function (e) { if (e.key === KEY) { paintToggles(); paintBar(); } });

  function init() { paintToggles(); paintBar(); renderPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
